import { Box, Flex, SimpleGrid, Spinner, Text, Tooltip } from '@chakra-ui/react';
import { HelperTooltip } from 'components/Tooltip';
import { QuestionIcon } from '@chakra-ui/icons';
import { renderInputElement } from 'helpers/formHelper';
import { formatRequiredFieldLabel } from 'helpers/requiredFieldLabel';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Controller } from 'react-hook-form';
import DownloadLink from "../../../../components/links/DownloadLink";

const REQUIRED_MARK_FIELD_NAMES = new Set([
  'installmentType',
  'transferDate',
  'purchasePriceDocument',
  'dealId',
  'fundingPercentage',
]);

const InstallmentSettings = ({
  fields,
  onFieldChange,
  control,
  isPageDisabled,
  dealContractFile,
  dealContractFileContent,
  dealContractFileLoading,
  purchasePriceFile,
  setPurchasePriceFile,
  purchasePriceFileContent,
  setPurchasePriceFileContent,
}) => {

  // console.log("InstallmentSettings", dealContractFile, dealContractFileContent );

  return (
    <SimpleGrid
      w={'max'}
      gridTemplateColumns={'min-content min-content min-content min-content'}
      whiteSpace={'nowrap'}
      justifyContent={'space-between'}
      spacingY={4}
      spacingX={10}
      alignItems={'start'}
      fontSize={'sm'}
    >
      {fields.map((item, index) => (
        <Fragment key={index}>
          {item.isHidden ? null : item.isCustomField ? (
            item.element
          ) : (
            <>
              <Flex align="center" gap={1} h={10}>
                <Text>
                  {formatRequiredFieldLabel(
                    item.label,
                    REQUIRED_MARK_FIELD_NAMES.has(item.name)
                  )}
                </Text>
                {item.helpLink ? (
                  <HelperTooltip content={item.tooltip} helpLink={item.helpLink} />
                ) : (
                  item.tooltip && (
                    <Tooltip label={item.tooltip} fontSize="xs" maxW="300px">
                      <QuestionIcon boxSize={3} color="gray.500" cursor="help" />
                    </Tooltip>
                  )
                )}
              </Flex>
              <Box w={200}>
                <Controller
                  control={control}
                  name={item.name}
                  render={renderInputElement({
                    item,
                    styleProps: { fontWeight: 800, w: 200 },
                    showPrefix: true,
                    isDisabled: isPageDisabled,
                    onChange: (name, value) => {
                      onFieldChange(name, value);
                    },
                  })}
                />
                {item.name === 'dealId' && dealContractFileLoading ? (
                  <Flex mt={1} align="center" gap={2}>
                    <Spinner size="sm" />
                    <Text fontSize="sm">Loading PDF…</Text>
                  </Flex>
                ) : item.name === 'dealId' && dealContractFile && dealContractFileContent ? (
                  <Box mt={1}>
                    <DownloadLink
                      filename={dealContractFile.name}
                      content={dealContractFileContent}
                      mimeType="application/pdf"
                    />
                  </Box>
                ) : null}
              </Box>
              <Box></Box>
              <Box></Box>
            </>
          )}
        </Fragment>
      ))}
    </SimpleGrid>
  );
};

InstallmentSettings.propTypes = {
  fields: PropTypes.array,
  onFieldChange: PropTypes.func,
  control: PropTypes.object,
  isPageDisabled: PropTypes.bool,
  dealContractFileLoading: PropTypes.bool,
};

export default InstallmentSettings;
